import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

interface PrivateRouteProps extends RouteProps {
    redirectTo: string | (() => string);
    authorize: () => boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, authorize, ...rest }) => {
    const isAuthorized = authorize();
    const redirectTo = typeof rest.redirectTo === 'string' ? rest.redirectTo : rest.redirectTo();
    return (
        <Route
            {...rest}
            render={({ location }) => {
                return isAuthorized ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: redirectTo,
                            state: { from: location },
                        }}
                    />
                );
            }}
        />
    );
};

export default React.memo(PrivateRoute);
